import apiClient from "../helpers/apiClient";

export const getSearchableMembers = async (where: string, keywords: string, category: string, limit?: number) => {
    // `limit` is optional and appended only when the caller asks for a bounded slice
    // (e.g. /main-dashboard shows the 15 most recent members). /members-search still calls
    // without `limit` so its paginated flow is unaffected. Positive integers only —
    // guard against NaN/negative values silently poisoning the URL.
    const limitParam = typeof limit === 'number' && Number.isFinite(limit) && limit > 0
      ? `&limit=${Math.floor(limit)}`
      : ''
    const response = await apiClient.get(`/users/search/?where=${where}&key=${keywords}${category ? `&category=${category}` : ''}${limitParam}`);
    return response.data.results;
};

export const getSearchableExperiences = async (where: string, keywords: string, category?: number, limit?: number) => {
    // Same rationale as getSearchableMembers: bounded slice for the dashboard, full list
    // for /experiences-search. Validate `limit` before building the URL.
    const limitParam = typeof limit === 'number' && Number.isFinite(limit) && limit > 0
      ? `&limit=${Math.floor(limit)}`
      : ''
    const response = await apiClient.get(`/experiences/search/?where=${where}&key=${keywords}${category ? `&category=${category}` : ''}${limitParam}`);
    return response.data.results;
};


export const getCategoriesMembers = async () => {
    const response = await apiClient.get('/members/member-types/');
    return response.data.results;
};

export const getNearbyMembers = async (search: string) => {
    const response = await apiClient.get(`/users/nearby/?where=${search}`);
    return response.data
}

export const getNearbyExperiences = async (search: string) => {
    const response = await apiClient.get(`/experiences/nearby/?where=${search}`);
    return response.data
}

